import { am5 } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

/**
 * Calculates the required width for axis labels based on the largest absolute value
 * in the last row of the data, formatted using am5's number formatter.
 *
 */
export const calculateLabelWidth = ({
  root,
  data,
  xAxisField,
}: {
  root: am5.Root;
  data?: types.widgets.TableData;
  xAxisField?: string;
}): number => {
  if (!data || !xAxisField || data.length === 0) {
    return 100;
  }

  const keys = Object.keys(data[0]).filter((key) => key !== xAxisField);
  if (keys.length === 0) {
    return 100;
  }

  const lastRow = data[data.length - 1];
  let maxAbsoluteValue = 0;

  keys.forEach((key) => {
    const value = lastRow[key];
    if (value !== null && value !== undefined) {
      const numValue = Math.abs(value as number);
      maxAbsoluteValue = Math.max(maxAbsoluteValue, numValue);
    }
  });

  if (maxAbsoluteValue === 0) {
    return 100;
  }

  const formatted = root.numberFormatter.format(maxAbsoluteValue);
  const textWithSpace = ` ${formatted}`;

  const charWidthMultiplier = 14;
  const safetyMargin = 5;
  const textWidth = textWithSpace.length * charWidthMultiplier + safetyMargin;
  return textWidth;
};
